<ng-container>
    <div>
        <h3>Census</h3>
    <div class="form-group">
        <label>Target WHPUOS</label>
        <input 
            type="number" 
            required 
            name="targetWhpuos" 
            [readonly]="readOnly" 
            [(ngModel)]="configuration.targetWHPUOS" 
            max="9999" 
            min="0" 
            pattern = "[0-9]{1,4}(\.[0-9]{0,3})?">
    </div>
    <div class="form-group">
        <label>Minimum Census</label>
        <input 
            type="number" 
            required 
            name="minimumCensus" 
            [readonly]="readOnly || isFutureShiftBlockAvailable" 
            [(ngModel)]="configuration.minCensus" 
            (change)="onChangeMinMaxCensus()"
            max="9999" 
            min="0">
        <span [hidden]="!invalidMinCensus" class="warning inline"><span class="icon-warning2"></span>Please ensure that minimum census is not a negative value.</span>
    </div>
    <div class="form-group">
        <label>Maximum Census</label>
        <input 
            type="number" 
            required 
            name="maximumCensus" 
            [readonly]="readOnly || isFutureShiftBlockAvailable" 
            [(ngModel)]="configuration.maxCensus" 
            (change)="onChangeMinMaxCensus()"
            max="9999" 
            min="0">
            <span [hidden]="!invalidMaxCensus" class="warning inline"><span class="icon-warning2"></span>Please ensure that maximum census is not a negative value.</span>
    </div>
    <span [hidden]="!invalidMinMax" class="warning inline"><span class="icon-warning2"></span>Please ensure that the minimum census is less than the maximum census.</span>
    <div class="form-group" [hidden]="readOnly">
        <label>Total Patient Type</label>
        <span class="inline warning" *ngIf="missingRatiosCheckbox"><span class="icon-warning2">            
        </span> Please select Total Patient Type</span>
        <span class="inline warning" *ngIf="missingRatios">
        <span class="icon-warning2"></span> Please add one or more Patient Ratios.</span>
        <ul class="options" >
            <li>
                <label>
                    <input type="radio" name="totalPatientCensus" (change)="onChangeTotalPatientCensus()" [value]="true" [(ngModel)]="configuration.totalPatientCensus">Census
                </label>
            </li>
            <li>
                <label>
                    <input type="radio" name="totalPatientCensus" (change)="onChangeTotalPatientCensus()" [value]="false" [(ngModel)]="configuration.totalPatientCensus">Ratio
                </label>
            </li>
        </ul>
    </div>
    <div class="form-group">
        <label>Transfers(In/Out)</label>
        <span class="inline warning" *ngIf="missingTransfersCheckbox">
        <span class="icon-warning2"></span> Please select whether this cost center accepts transfers in/out.</span>
        <ul class="options" >
            <li>
                <label>
                    <input type="radio" name="transfers" (change)="validate()" [value]="true" [attr.disabled]="isRadioButtonReadOnly" [(ngModel)]="configuration.transfers">Yes
                </label>
            </li>
            <li>
                <label>
                    <input type="radio" name="transfers" (change)="validate()" [value]="false" [attr.disabled]="isRadioButtonReadOnly" [(ngModel)]="configuration.transfers">No
                </label>
            </li>
        </ul>
    </div>
    </div>
    <div class="form-group" [hidden]="shouldDisplayPatientRatios">
        <div>
            <h3>Ratios</h3>
        <div class="form-group inline-control">
            <button *ngIf="!readOnly" type="button" (click)="onAddPatientRatio()">
                <span class="icon-plus"></span> Add Patient Ratio
            </button>
        </div>
        <table role="list" class="condensed">
          <caption>
            <span class="inline warning" *ngIf="isValidStaffAndPatientValue">
              <span class="icon-warning2">
              </span> Please ensure the value entered for staff and patient is greater than 0.
            </span>           
          </caption>
          <thead>
            <tr>
                <th>Label</th>
                <th>Staff</th>
                <th></th>
                <th>Patient</th>
                <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ratio of configuration.patientRatios; let i = index">
              <td><input maxlength="20" type="text" required [disabled]="readOnly" name="ratioLabel-{{i}}" [(ngModel)]="ratio.label"></td>
              <td><input type="number" required pattern="[1-9][0-9]{0,3}$" [disabled]="readOnly" name="ratioStaff-{{i}}" [(ngModel)]="ratio.staffs" max="9999" min="1"></td>
              <td>:</td>
              <td><input type="number" required pattern="[1-9][0-9]{0,3}$" [disabled]="readOnly" name="ratiopatients-{{i}}" [(ngModel)]="ratio.patients" max="9999" min="1"></td>
              <td><button *ngIf="!readOnly" type="button" id="removeButton-{{i}}" (click)="onRemovePatientRatio(i)"><span class="icon-bin"></span> Remove</button></td>
            </tr>
          </tbody>
        </table>
    </div>
</div>

</ng-container>
